import type { ReactNode } from 'react';
import stile from './states.module.css';
import { LinienSymbol, type LinienSymbolName } from './linien-symbol.js';

export function LoadingState({ text }: { text: string }) {
  return (
    <p role="status" className="eds-text-secondary">
      {text}
    </p>
  );
}

export function EmptyState({
  titel,
  text,
  symbol,
  children,
}: {
  titel: string;
  text: string;
  symbol?: LinienSymbolName;
  children?: ReactNode;
}) {
  return (
    <div className="eds-card">
      {symbol && (
        <span className={stile.symbol}>
          <LinienSymbol name={symbol} groesse={32} />
        </span>
      )}
      <p className="eds-card__title">{titel}</p>
      <p className="eds-card__body">{text}</p>
      {children}
    </div>
  );
}

export function ErrorState({ text, onWiederholen }: { text: string; onWiederholen?: () => void }) {
  return (
    <div className="eds-alert eds-alert--error" role="alert">
      <div>
        <p>{text}</p>
        {onWiederholen && (
          <button
            className="eds-button eds-button--secondary"
            type="button"
            onClick={onWiederholen}
          >
            Erneut versuchen
          </button>
        )}
      </div>
    </div>
  );
}
